import { useState } from "react";
import "./style.scss";
import { Link, useNavigate } from "react-router-dom";
import Sidebar from "../sidebar";
import Header from "../header";
import methodModel from "../../../methods/methods";
import { useSelector } from "react-redux";
import { memo } from 'react';


const Layout=memo(function Layout ({ children }) {
  const user = useSelector((state) => state.user);
  const history = useNavigate();
  const [isOpen, setIsopen] = useState(false);

  const logowhite = () => {
    let value = "/assets/img/sales-logo.png";
    return value;
  };

  const logos = () => {
    let value = "/assets/img/sales-small.png";
    return value;
  };

  const router = () => {
    let route = localStorage.getItem("route");
    history(route);
  };

  return (
    <>
      <div component="layout">
        <div onClick={(e) => router()} id="routerDiv"></div>
        <Header isOpen={isOpen} setIsOpen={setIsopen} />

        <div className={`main-wrapper flex ${isOpen ? "active-sidebar" : ""}`}>
          <div className="main-sidebar scrollbar transition-[width] duration-300 ">
            <div className="sidebar-brand text-center p-[9px] bg-white">
              <Link to="/">
                <div className="editLogo">
                  <img
                    src={logowhite()}
                    width=""
                    height="30"
                    className=" show-logo w-[140px] "
                  />
                  <img src={logos()} className="hide-logo " height="30"/>
                </div>
              </Link>
              {/* <p className="text-gray-900 text-[16px] pt-[4px] name-site">Sales Management</p> */}
            </div>
            {user?.logo ? (
              <div
                className="flex justify-center"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  src={methodModel.userImg(user?.logo || "")}
                  alt="photo"
                  width="40"
                  height="40"
                  style={{
                    width: "40px",
                    marginBottom: "2px",
                    height: "40px",
                    borderRadius: "50%",
                  }}
                />
              </div>
            ) : null}
            <Sidebar isOpen={isOpen} />
          </div>

          {/* <div className="main-sidebar  d-md-block">

            <div className="sidebar-brand p-3 pt-4  text-left pl-5">
              <label className='editLogo'>
                <img src={logo()} className="logocls show-logo" />
                <img src={logos()} className=" hide-logo" />
              </label>

            </div>
            <Sidebar />
          </div> */}
          <main className="main">
            <div className="mainarea">
              {children}
            </div>
          </main>
        </div>
      </div>
    </>
  );
});
export default Layout;
